import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { SellingCompanyShipper } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SellingCompanyShipperService extends TmsWebBaseEditCreateService<
  SellingCompanyShipper,
  SellingCompanyShipper
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SellingCompanyShipper', $localize`Selling Company Shipper`);
  }

  getForSellingCompany(id: string): Observable<SellingCompanyShipper[]> {
    return this.httpService.get<SellingCompanyShipper[]>(`${this.apiUrl}/GetForSellingCompany?id=${id}`);
  }
}
